import { useCallback, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PinField } from 'react-pin-field';

import type { FC } from 'react';

import * as styles from './PinInputs.module.scss';

interface PinInputsProps {
  onPinInputEnter?: (pin: string) => void;
  codeToValidate?: string;
  checkPinCorrection?: (value: boolean) => void;
  checkPinIncorrect?: (value: boolean) => void;
}

const PinInputs: FC<PinInputsProps> = ({
  onPinInputEnter,
  codeToValidate,
  checkPinCorrection,
  checkPinIncorrect,
}) => {
  const { t } = useTranslation();
  const [code, setCode] = useState<string>('');
  const isIncorrect =
    code.length === 4 && codeToValidate && codeToValidate !== code;

  const onPinChange = useCallback(
    (pin: string) => {
      setCode(pin);
      if (onPinInputEnter) {
        onPinInputEnter(pin);
      }

      if (checkPinCorrection) {
        checkPinCorrection(Boolean(codeToValidate && pin === codeToValidate));
      }

      if (checkPinIncorrect) {
        checkPinIncorrect(
          Boolean(pin.length === 4 && codeToValidate && codeToValidate !== pin)
        );
      }
    },
    [checkPinCorrection, onPinInputEnter, checkPinIncorrect, codeToValidate]
  );

  return (
    <div className={styles.container}>
      <div className={styles.pins}>
        <PinField
          className={classNames(styles.pinField, {
            [styles.isIncorrect]: isIncorrect,
          })}
          length={4}
          type="password"
          validate="0123456789"
          inputMode="numeric"
          onChange={(pin) => onPinChange(pin)}
        />
      </div>
      {isIncorrect && (
        <div className={styles.errorMessage}>
          {t('Wrong code... Try again')}
        </div>
      )}
    </div>
  );
};

export { PinInputs };
